export default __webpack_public_path__ + "static/media/cargo_bike.85a9691c.svg";